<template>
  <div class="largeScreen-wrap">
    <div class="largeScreen-header">
      <div class="title">资产漏洞态势</div>
      <div class="date">
        <RangePicker
          @dataPickerTime="selectTime"
          :defaultDate="defaultDate"
          :timeFrame="90"
        />
      </div>
    </div>
    <div class="largeScreen-content">
      <div class="content-left">
        <!-- 资产总数 -->
        <AppTotal :data="appTotalData" />
        <!-- 风险资产等级分布 -->
        <RiskLevel :data="riskLevelData" :counter="counter" />
        <!-- 风险应用top10 -->
        <RiskAppTop :data="riskAppTopData" :counter="counter" />
      </div>
      <div class="content-right">
        <div class="content-right-top">
          <div class="content-right-top-left">
            <div class="content-right-top-data">
              <!-- 风险资产数、风险资产占比 -->
              <div
                v-for="item in COUNTLIST"
                :key="item.value"
                :style="{ width: `${100 / COUNTLIST.length}%` }"
                class="content-right-top-item"
              >
                <CardBorder />
                <CountList
                  :data="countListData?.[item.key] || 0"
                  :item="item"
                />
              </div>
            </div>
            <!-- 风险值 -->
            <div class="content-right-bottom-data">
              <ScoreWrapper :data="scoreData" :name="scoreNameData" />
            </div>
          </div>
          <div class="content-right-top-right">
            <div :style="'width: 100% '" class="content-right-top-item">
              <CardBorder />
              <!-- 风险数 -->
              <RiskCount
                :data="countListData?.[RISKCONFIG.key] || 0"
                :levelData="countListData?.['riskLevel'] || null"
                :item="RISKCONFIG"
              />
            </div>
            <!-- 风险类型 -->
            <RiskType :data="riskTypeData" :counter="counter" />
          </div>
        </div>
        <div class="content-right-bottom">
          <RiskNum :data="riskNumData" :counter="counter" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import dayjs from "dayjs";
import RangePicker from '@/components/common/range-picker.vue';
import AppTotal from './components/appTotal/index.vue';
import RiskLevel from './components/riskLevel/index.vue';
import RiskType from './components/riskType/index.vue';
import RiskAppTop from './components/riskAppTop10/index.vue';
import CountList from './components/countList/index.vue';
import RiskCount from './components/riskCount/index.vue';
import RiskNum from './components/riskNum/index.vue';
import ScoreWrapper from './components/scoreData/index.vue';
import CardBorder from "@/components/common/card-border.vue";
import { addColor } from '@/utils/addColor.js';
import { getRiskSummary } from '@/api/largeScreen.js';

export default {
  components: {
    RangePicker,
    RiskLevel,
    AppTotal,
    RiskAppTop,
    CountList,
    RiskCount,
    RiskType,
    RiskNum,
    ScoreWrapper,
    CardBorder,
  },
  setup() {
    const COUNTLIST = [
      {
        title: '风险资产数',
        bg: 'countbg1',
        key: 'assetsRiskNum'
      },
      {
        title: '风险资产占比',
        bg: 'countbg2',
        key: 'assetsNumRate'
      }
    ];
    const RISKCONFIG = {
      title: '风险数',
      bg: 'countbg3',
      key: 'riskTotal'
    };
    let timer = null;
    const appTotalData = ref('');   //app资产总数
    const riskAppTopData = ref(null);// 风险应用top5
    const riskLevelData = ref(null); //风险资产等级分布
    const riskTypeData = ref(null);//风险类型
    const countList = ref(COUNTLIST); //统计列表
    const countListData = ref(null); //统计列表
    const LoopholeTypeData = ref([]);//漏洞风险类型
    const GRCTypeData = ref([]);//隐私合规风险类型
    const riskNumData = ref(null);//检测风险数量变化
    const scoreData = ref(0);
    const scoreNameData = ref(null);
    const counter = ref(0);
    onMounted(() => {
      timer = setInterval(() => {
        counter.value++;
        if (counter.value === 5) {
          counter.value = 0;
        }
      }, 1000);
    });
    // 默认日期
    const defaultDate = localStorage.rangeDate?.split(',') || [dayjs().subtract(1, "day"), dayjs().subtract(7, "day")];
    let monday = dayjs(defaultDate[0]).format("YYYY-MM-DD");
    let sunday = dayjs(defaultDate[1]).format("YYYY-MM-DD");
    // 日历选择
    const selectTime = (val) => {
      if (val) {
        monday = dayjs(val[0]).format("YYYY-MM-DD");
        sunday = dayjs(val[1]).format("YYYY-MM-DD");
        // timePicker.st = monday;
        // timePicker.et = sunday;
        let params = {
          starttime: monday,
          endtime: sunday
        };
        getData(params);
      }
    };
    const getData = async (params) => {
      getRiskSummary(params || {}).then((res) => {
        const { data } = res;
        if (data) {
          //app资产总数
          appTotalData.value = {
            assetsNum: data.top.assetsNum,
            ...data.assets
          };

          let newTop10 = { ...data.top5 };
          // for (let i in newTop10) {
          //   let newObj = {};
          //   // 如果数据不足10条
          //   if (newTop10[i].length < 10) {
          //     // 计算需要补几条
          //     let num = 10 - newTop10[i].length;
          //     // 复制对象里的字段
          //     for (let j in newTop10[i][0]) {
          //       newObj[j] = '-';
          //       if (Number(newTop10[i][0][j])) {
          //         newObj[j] = 0;
          //       }
          //     }
          //     for (let k = 0; k < num; k++) {
          //       newTop10[i].push(newObj);
          //     }
          //   }
          // }
          // 风险应用top10
          riskAppTopData.value = newTop10;
          // 风险应用top5
          // riskAppTopData.value = {
          //   ...data.top5
          // };
          riskLevelData.value = {
            ...data.assetsLevel
          };
          riskTypeData.value = {
            ...data.risk
          };
          countListData.value = { ...data.top };
          LoopholeTypeData.value = [...data.risk.scan];
          GRCTypeData.value = [...data.risk.compliance];
          riskNumData.value = { ...res.data.trend };
          scoreData.value = data.top.score;
          scoreNameData.value = data.top.scoreName;

        }
      });
    };
    getData({
      starttime: monday,
      endtime: sunday
    });

    return {
      addColor,
      defaultDate,
      selectTime,
      monday,
      sunday,
      COUNTLIST,
      RISKCONFIG,
      appTotalData,
      riskAppTopData,
      riskLevelData,
      riskTypeData,
      countList,
      countListData,
      LoopholeTypeData,
      GRCTypeData,
      riskNumData,
      scoreData,
      scoreNameData,
      counter
    };
  }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
